import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import AddExportModelModal from "@/components/export-model/add-export-model-modal";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import { useBoolean } from "@/hooks/use-boolean";
import { PlusIcon } from "@radix-ui/react-icons";
import useTranslation from "@babackapp/translations/use-translation";

type ModelSelectorProps = {
  value: string;
  onChange: (value: string) => void;
};

export default function ModelSelector({ value, onChange }: ModelSelectorProps) {
  const t = useTranslation();
  const addExportModelModalOpen = useBoolean(false);

  const models = useCurrentShopSuspense().data.exportModels;

  const _onChangeHandler = (value: string) => {
    if (value === "add") return addExportModelModalOpen.setValue(true);
    onChange(value);
  };

  return (
    <>
      <AddExportModelModal
        open={addExportModelModalOpen.value}
        onOpenChange={addExportModelModalOpen.setValue}
      />
      <Select value={value} onValueChange={_onChangeHandler}>
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {models.map((model) => (
            <SelectItem value={model.id} className="py-2">
              {model.title}
            </SelectItem>
          ))}
          <SelectItem className="py-2" value="add">
            <span className="flex items-center gap-2">
              <PlusIcon className="w-4 h-4" />
              {t("misc.add")}
            </span>
          </SelectItem>
        </SelectContent>
      </Select>
    </>
  );
}
